import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {OrderService} from "../../core/http/order.service";
import {TableNumberService} from "../../core/http/table-number.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {PrintReceiptModalComponent} from "../../shared/components/print-receipt-modal/print-receipt-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {clone, cloneDeep} from 'lodash-es';
import {Order} from "../../shared/models/Order";
import {ItemsService} from "../../core/http/items.service";
import {CategoryDto} from "../../shared/models/category-dto";
import {Category} from "../../shared/models/category";
import {Item} from "../../shared/models/item";
import {OrderPosition} from "../../shared/models/OrderPosition";
import {AuthService} from "../../core/auth/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {catchError, finalize, map, Observable, of} from "rxjs";

@Component({
  selector: 'app-split-receipt',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  animations: [
    // trigger('slideInOut', [
    //   state(
    //     'void',
    //     style({
    //       transform: 'translateY(100%)',
    //       opacity: 0
    //     })
    //   ),
    //   state(
    //     '*',
    //     style({
    //       transform: 'translateY(0%)',
    //       opacity: 1
    //     })
    //   ),
    //   transition(':enter', animate('300ms ease-in-out')),
    //   transition(':leave', animate('300ms ease-in-out'))
    // ])
  ]
})
export class CheckoutComponent implements OnInit, OnDestroy {

  restOrder?: Order;
  selectedPositions: string[] = [];
  selectedPositionsForSplit: string[] = [];
  paidPositions: string[] = [];
  categories?: CategoryDto[];
  splitAmount: number = 0;
  restAmount: number = 0;
  isLoading = false;

  constructor(
    private router: Router,
    public orderService: OrderService,
    public tableNumberService: TableNumberService,
    public itemsService: ItemsService,
    public dialog: MatDialog,
    private authService: AuthService,
    private _snackBar: MatSnackBar) {

  }

  ngOnInit() {
    // if page was reloaded and no order is set
    if (!this.orderService.getOrder()) {
      // check if order in state
      const restOrderFromState = sessionStorage.getItem('restOrderState');
      const originalOrderFromState = sessionStorage.getItem('originalOrderState');
      const paidPositionsFromState = sessionStorage.getItem('paidPositionsState');
      const tableNumberFromState = sessionStorage.getItem('tableNumberState');
      if (restOrderFromState && originalOrderFromState && tableNumberFromState) {
        this.tableNumberService.setTableNumber(JSON.parse(tableNumberFromState).tableNumber);
        this.restOrder = JSON.parse(restOrderFromState).restOrder;
        this.orderService.setOrder(JSON.parse(originalOrderFromState).originalOrder);
        if (paidPositionsFromState) {
          this.paidPositions = JSON.parse(paidPositionsFromState).paidPositions;
          this.selectedPositions = JSON.parse(paidPositionsFromState).selectedPositions;
          this.restAmount = JSON.parse(paidPositionsFromState).restAmount;
        }
      } else {
        this._snackBar.open('Keine Bestellung zum Abrechnen vorhanden. Bitte Bestellung aufnehmen.', 'Schließen', {duration: 10000});
        this.tableNumberService.resetFlow();
        this.isLoading = false;
        sessionStorage.removeItem('restOrderState');
        sessionStorage.removeItem('originalOrderState');
        sessionStorage.removeItem('paidPositionsState');
        sessionStorage.removeItem('tableNumberState');
        this.router.navigate(['/tablenumber']).then(r => {
        });
        return;
      }
    }
    this.tableNumberService.setInCheckoutFlow(true);
    this.itemsService.getAllAvailableCategoriesAndItems().subscribe(data => {
      this.categories = data;
    });
    this.orderService.getOrder().positions!.sort((a, b) => a.sortId - b.sortId);
    this.restOrder = cloneDeep(this.orderService.getOrder());
    sessionStorage.setItem('restOrderState', JSON.stringify({
      restOrder: this.restOrder
    }));
    sessionStorage.setItem('originalOrderState', JSON.stringify({
      originalOrder: cloneDeep(this.orderService.getOrder())
    }));
    sessionStorage.setItem('tableNumberState', JSON.stringify({
      tableNumber: this.tableNumberService.getTableNumber()
    }));
    this.restAmount = this.restAmount ? this.restAmount : this.getTotalRestAmount();
  }

  isShowCategory(category: CategoryDto): boolean {
    if (this.restOrder && this.restOrder.positions) {
      return this.restOrder!.positions!.filter(pos => pos.categoryIdentifier === category.category.identifier).length > 0;
    }
    return false;
  }

  ngOnDestroy() {
    this.tableNumberService.resetFlow();
  }

  addItem(orderPosition: OrderPosition): void {
    if (this.getSelectedAmountOfPosition(orderPosition) + 1 <= this.getTotalOrderedAmountOfPosition(orderPosition)) {
      this.selectedPositions.push(orderPosition.itemGuid);
      this.selectedPositionsForSplit.push(orderPosition.itemGuid);
      this.splitAmount += orderPosition.itemPrice;
    }
  }

  removeItem(orderPosition: OrderPosition): void {
    const index = this.selectedPositions.indexOf(orderPosition.itemGuid, 0);
    const indexForSplit = this.selectedPositionsForSplit.indexOf(orderPosition.itemGuid, 0);
    if (index > -1 && this.getSelectedAmountOfPosition(orderPosition) - 1 >= this.paidPositions.filter(sp => sp === orderPosition.itemGuid).length) {
      this.selectedPositions.splice(index, 1);
      this.selectedPositionsForSplit.splice(indexForSplit, 1);
      this.splitAmount -= orderPosition.itemPrice;
    }
  }

  getSelectedAmountOfPosition(position: OrderPosition): number {
    return this.selectedPositions.filter(pos => pos === position.itemGuid).length;
  }

  getTotalOrderedAmountOfPosition(position: OrderPosition): number {
    return this.orderService.getOrder().positions!.filter(pos => pos.itemGuid === position.itemGuid)[0].quantity;
  }

  getItemsOfCurrentCategory(category: CategoryDto): OrderPosition[] {
    if (this.restOrder && this.restOrder.positions) {
      return this.restOrder.positions.filter(pos => pos.categoryIdentifier === category.category.identifier);
    }
    return [];
  }

  getTotalRestAmount(): number {
    if (this.restOrder && this.restOrder.positions) {
      const total = this.restOrder.positions.reduce((acc, item) => {
        const itemValue = item.itemPrice * item.quantity;
        return acc + itemValue;
      }, 0);
      return total;
    }
    return 0;

  }

  getButtonFontSize(item: string): string {
    const maxLength = 20; // Maximum length before reducing font size
    const defaultFontSize = 16; // Default font size
    const reductionFactor = 0.5; // Font size reduction factor

    if (item.length > maxLength) {
      const fontSize = defaultFontSize - Math.floor((item.length - maxLength) * reductionFactor);
      return `${fontSize}px`;
    }
    return `${defaultFontSize}px`;
  }

  onCheckout(method: string): void {
    if (method === 'rest') {
      if (this.restAmount > 0) {
        const dialogRef = this.dialog.open(PrintReceiptModalComponent, {
          width: '400px',
          data: {
            totalAmount: this.restAmount
          },
          autoFocus: false
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result === 'yes') {
            this.orderService.getOrder().printReceipt = true;
          } else {
            this.orderService.getOrder().printReceipt = false;
          }
          // route back for a new order
          if (result !== undefined && result !== null && result !== '') {
            this.isLoading = true;
            this.printReceipt(true).pipe(
              finalize(() => this.isLoading = false)
            ).subscribe(success => {
            });
          }
        });
      }
    } else if (method === 'part') {
      if (this.splitAmount > 0) {
        const dialogRef = this.dialog.open(PrintReceiptModalComponent, {
          width: '400px',
          data: {
            totalAmount: this.splitAmount
          },
          autoFocus: false
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'yes') {
            this.orderService.getOrder().printReceipt = true;
          } else {
            this.orderService.getOrder().printReceipt = false;
          }
          // if order finished / everything paid, route back for a new order
          if (result !== undefined && result !== null && result !== '') {
            this.isLoading = true;
            this.printReceipt(false).pipe(
              finalize(() => this.isLoading = false)
          ).subscribe(success => {
              if (success) {
                this.restAmount = this.restAmount - this.splitAmount;
                this.splitAmount = 0;
                this.paidPositions.push(...this.selectedPositionsForSplit);
                this.selectedPositionsForSplit = [];

                sessionStorage.setItem('paidPositionsState', JSON.stringify({
                  paidPositions: this.paidPositions,
                  selectedPositions: this.selectedPositions,
                  restAmount: this.restAmount
                }));

                // remove fully paid items from restOrder
                if (this.restOrder && this.restOrder.positions && this.orderService.getOrder()) {
                  this.restOrder!.positions = this.restOrder?.positions?.filter(pos => {
                    return this.selectedPositions
                      .filter(selPos => selPos === pos.itemGuid).length !== this.orderService.getOrder().positions!
                      .find(origPos => origPos.itemGuid === pos.itemGuid)?.quantity;
                  });
                  sessionStorage.setItem('restOrderState', JSON.stringify({
                    restOrder: this.restOrder
                  }));
                }
              }
            });
          }
        });
      }
    }
  }

  printReceipt(rest: boolean): Observable<boolean> {
    let receiptOrder = cloneDeep(this.orderService.getOrder());
    if (rest) {
      receiptOrder.positions!.forEach(pos => {
        return pos.quantity = pos.quantity - this.paidPositions.filter(selectedPos => selectedPos === pos.itemGuid).length;
      });
      // receiptOrder.positions = receiptOrder.positions!.filter(pos => !this.selectedPositions.includes(pos.itemGuid));
    } else {
      receiptOrder.positions!.forEach(pos => {
        return pos.quantity = this.selectedPositionsForSplit.filter(selectedPos => selectedPos === pos.itemGuid).length;
      });
    }

    return this.orderService.sendReceipt(receiptOrder).pipe(
      map(response => {
        console.log('send receipt');
        if (rest || (this.restAmount - this.splitAmount === 0)) {
          // reset order from order service
          this.orderService.clearOrder();
          this.tableNumberService.resetFlow();
          sessionStorage.removeItem('restOrderState');
          sessionStorage.removeItem('originalOrderState');
          sessionStorage.removeItem('paidPositionsState');
          sessionStorage.removeItem('tableNumberState');
          this.router.navigate(['/tablenumber']).then(r => {
          });
        }
        return true;
      }),
      catchError(err => {
        console.error('Fehler beim Senden der Rechnung', err);
        this._snackBar.open('Rechnung wurde nicht erstellt! Erneut versuchen.', 'Schließen', {duration: 10000});
        return of(false);
      })
    );
  }

}
